<template lang="html">
  <div class="model">
    <!-- <h3>修改个性签名</h3> -->
    <div class="input-box">
      <input type="text" v-model="signName"  value="">
      <img src="../../../assets/images/closed.svg" @click="reset" alt="">
    </div>
    <button class="model-submit" @click="editUser" type="button" name="button">确认修改</button>
    <Tip v-if="message" :label="label"/>
  </div>
</template>

<script>
import { put } from '../../../utils/request'
import { get, set } from '../../../utils/token'
import Tip from '../../../components/message.vue'
import { createNamespacedHelpers } from 'vuex'
const { mapGetters, mapActions } = createNamespacedHelpers('user')
export default {
  components: {
    Tip
  },
  data () {
    return {
      signName: '',
      message: false,
      label: ''
    }
  },
  mounted () {
    document.title = '修改签名'
    const _user = get('user')
    this.signName = _user ? _user.signName : ''
  },
  methods: {
    reset () {
      this.signName = ''
    },
    ...mapGetters({
      getUser: 'getUser'
    }),
    ...mapActions({
      updateUserSignName: 'updateUserSignName'
    }),
    editUser () {
      const user = this.getUser() || get('user')
      const promise = put({
        url: `/user/updateUserInfo/${user ? user.id : ''}`,
        data: {
          signName: this.signName
        }
      })
      promise.then(res => {
        const { data: { message, detail } } = res
        if (Object.is(message, '用户信息更新完成')) {
          // this.message = true
          // this.label = message
          if (user) {
            Object.assign(user, detail)
            user.password = this.password
          }
          set('user', user)
          this.updateUserSignName(user.signName)
          this.$router.back()
        } else {
          this.message = true
          this.label = message
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.model {
  width: 100%;
  height: 100vh;
  background:rgba(242,242,247,1);
  h3 {
    text-align: center;
    padding: 9px 0;
    margin-bottom: 16px;
    font-size:17px;
    font-family:SFProText-Semibold,SFProText;
    font-weight:600;
    color:rgba(0,0,0,1);
    line-height:22px;
    border-bottom: 1px solid #E2E2E2;
    background:rgba(242,242,247,1);
  }
  .input-box {
    width: 100%;
    height:58px;
    box-sizing: border-box;
    background: #fff;
    padding: 18px 24px;
    display: flex;
    justify-content: space-between;
    input {
      border: none;
      outline: none;
      width: 60vw;
      font-size: 16px;
    }
  }
  .model-submit {
    box-sizing: border-box;
    width: 91.47vw;
    margin: 27px 4.27vw 0;
    height:44px;
    background:rgba(24,204,159,1);
    border-radius:5px;
    font-size:17px;
    font-family:PingFangSC-Regular,PingFang SC;
    font-weight:400;
    color:rgba(255,255,255,1);
    line-height:24px;
    border: 0;
  }
}
</style>
